export const container = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const tabDesign = { marginLeft: "33%" };
